// Module
var code = "<ul> <li ng-repeat=\"r in $ctrl.list.USE\"> <span ktranslate=\"r.kid\" ng-class=\"{'field-required': r.required }\"></span> </li> </ul> ";
// Exports
export default code;